class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, cartItemsCount = 0) {
      this.cartItemKey = parsedState.key;
      const newParsedState = this.customizeRender(parsedState, cartItemsCount)
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(newParsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  customizeRender(parsedState, cartItemsCount) {
    const handler = {
      'cart-icon-bubble': (string) => {
        const svgRegex = /<svg(.|\n)*<\/svg>/g
        const svgReplacement = `
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25013 5.01489C6.25003 5.00994 6.24998 5.00498 6.24998 5V4C6.24998 1.92893 7.92892 0.25 9.99998 0.25C12.0711 0.25 13.75 1.92893 13.75 4V5C13.75 5.00498 13.7499 5.00994 13.7498 5.01489C15.0371 5.05353 15.8248 5.1924 16.4261 5.69147C17.2593 6.38295 17.4787 7.55339 17.9177 9.89427L18.6677 13.8943C19.2849 17.186 19.5934 18.8318 18.6937 19.9159C17.794 21 16.1195 21 12.7704 21H7.22954C3.88048 21 2.20595 21 1.30624 19.9159C0.406518 18.8318 0.715115 17.186 1.33231 13.8943L2.08231 9.89427C2.52122 7.55339 2.74068 6.38295 3.57386 5.69147C4.17521 5.1924 4.96287 5.05353 6.25013 5.01489ZM7.74998 4C7.74998 2.75736 8.75734 1.75 9.99998 1.75C11.2426 1.75 12.25 2.75736 12.25 4V5C12.25 4.99999 12.25 5.00001 12.25 5C12.1747 4.99998 12.0982 5 12.0204 5H7.97954C7.90176 5 7.82525 5 7.74998 5.00002C7.74998 5.00002 7.74998 5.00003 7.74998 5.00002V4Z" fill="#19222A"></path>
        </svg>`
        return string.replace(svgRegex, svgReplacement)
      },
      'cart-notification-product': (string) => {
        const html = new DOMParser().parseFromString(string, 'text/html')
        const items = html.querySelectorAll('.cart-item')
        items.forEach(item => {
          const options = Array.from(item.querySelectorAll('dd')).map(opt => opt.innerHTML).join(', ')
          item.querySelector('dl').remove()
          if (options) {
            item.querySelector('.cart-notification-product__name').innerHTML += `, ${options}`
          }
          if (cartItemsCount) {
            item.querySelector('.other-cart-items').innerHTML = `+${cartItemsCount} item lainnya`;
          }
        })
        return html.documentElement.outerHTML
      }
    }
    const newSections = Object.entries(parsedState.sections)
      .reduce((obj, [key, value]) => {
        obj[key] = handler[key]?.(value) ?? value
        return obj
      }, {})
    parsedState.sections = newSections
    return parsedState
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
